import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MobileStepper, Button, Box, LinearProgress } from "@material-ui/core";
import getBrandFromUrl from "src/utils/getBrandFromUrl";

// Define the steps and their corresponding routes
const stepPages = [
  "/vehicleincidents/vehicleconditionandpolice",
  "/vehicleincidents/incidentdetails",
  "/vehicleincidents/thirdpartydetails",
  "/vehicleincidents/witnessdetails",
  "/vehicleincidents/damagedetails",
  "/vehicleincidents/reviewpage",
  "/vehicleincidents/submissionpage",
];

const StepperNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const brand = getBrandFromUrl();

  // Find the current step index
  const activeStep = stepPages.indexOf(location.pathname);
  const totalSteps = stepPages.length;
  useEffect(() => {
    if (location.pathname === "/vehicleincidents/submissionpage") {
      const handlePopState = () => {
        navigate("/vehicleincidents/incidentselection" + `?brand=${brand}`, { replace: true });
      };

      window.addEventListener("popstate", handlePopState);

      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [location.pathname, navigate]);
  // Hide stepper if the current page is not in stepPages
  if (activeStep === -1) {
    return null;
  }

  return (
    <Box position="fixed" bottom={0} left={0} width="100%" bgcolor="white" zIndex={1300} p={1}>
      {/* Progress Bar */}
      <LinearProgress
        variant="determinate"
        value={(activeStep / (totalSteps - 1)) * 100}
        sx={{ mb: 1 }}
      />

      {/* Mobile Stepper (Without Buttons) */}
      <MobileStepper
        variant="dots"
        steps={totalSteps}
        position="static"
        activeStep={activeStep}
        nextButton={null} // Removed Next Button
        backButton={null} // Removed Back Button
      />
    </Box>
  );
};

export default StepperNavigation;
